import clsx from 'clsx';
import { useAppContext } from 'contexts/appContext';
import { CloseModalButton } from '../CloseModalButton/CloseModalButton';
import styles from './AllFiltersHeader.css';

interface AllFiltersHeaderProps {
	selectionCount: number;
}

export function AllFiltersHeader({ selectionCount }: Readonly<AllFiltersHeaderProps>) {
	const { dictionary } = useAppContext();
	const { actionAllFilters: allFiltersLabel } = dictionary;

	return (
		<header data-testid="mobile-all-filters-header-label" className={clsx(styles.root, { [styles.selected]: selectionCount > 0 })}>
			<span className={styles.title}>{allFiltersLabel}</span>
			<CloseModalButton testId="mobile-close-filter-modal-button" />
		</header>
	);
}
